module.exports = __webpack_public_path__ + "static/media/calibration_setp1_wrong.a6780905.png";